enum InvoiceColumns {
  'invoiceNumber' = 'Inv.no',
  'invoiceDate' = 'Inv.date',
  'invoiceExportReason' = 'Inv.export',
  'invoiceIncoterm' = 'Inv.incoterm',
  'invoiceUnitOfMeasurement' = 'inv.UOM',
  'placeOfIncoterm' = 'PlaceofIncoterm',
  'lineItems' = 'LineItems',
  'noOfLineItem' = 'No.lineItem',
  'lineItemNumber' = 'LineItemNumber',
  'lineItemDescription' = 'Description',
  'lineItemUnitPrice' = 'UnitPrice',
  'lineItemUnitPriceCurrency' = 'Currency',
  'lineItemQuantity' = 'Quantity',
  'lineItemQuantityUnitofMeasurement' = 'Quant.UOM',
  'lineItemExportCommodityCode' = 'Export.CC',
  'lineItemImportCommodityCode' = 'Import.CC',
  'lineItemReference' = 'Reference',
  'lineItemPartNumber' = 'PartNumber',
  'lineItemExportReasonType' = 'ExportReasonType',
  'lineItemManufactureCountry' = 'Man.Country',
  'lineItemNetWeight' = 'NetWeight',
  'lineItemGrossWeight' = 'GrossWeight',
}

export { InvoiceColumns };
